import { IconButton, makeStyles, TableCell, TableRow } from '@material-ui/core';
import { Add as AddIcon, BrokenImage as BrokenImageIcon } from '@material-ui/icons';

import { PRODUCT_IMAGE_PATH } from '../../../products/constants/products-app-paths.constants';
import { Product } from '../../../products/types/product.type';

const useStyles = makeStyles((theme) => ({
  photo: { width: 40, height: 40, objectFit: 'cover' as const, borderRadius: 4 },
  photoFallback: { width: 40, height: 40, color: theme.palette.grey[400] },
}));

type Props = { product: Product; onAdd: (product: Product) => void; disabled?: boolean };

export function CatalogProductRow({ product, onAdd, disabled = false }: Props) {
  const classes = useStyles();
  return (
    <TableRow hover>
      <TableCell style={{ width: 56 }}>
        {product.photo ? (
          <img src={PRODUCT_IMAGE_PATH(product.photo)} alt="" className={classes.photo} />
        ) : (
          <BrokenImageIcon className={classes.photoFallback} />
        )}
      </TableCell>
      <TableCell>{product.name}</TableCell>
      <TableCell>{product.reference}</TableCell>
      <TableCell>{product.subCategory?.name ?? '—'}</TableCell>
      <TableCell align="right">{product.price.toFixed(2)} €</TableCell>
      <TableCell align="right" style={{ width: 56 }}>
        <IconButton
          size="small"
          aria-label={`Ajouter ${product.name}`}
          disabled={disabled}
          onClick={() => onAdd(product)}
        >
          <AddIcon fontSize="small" />
        </IconButton>
      </TableCell>
    </TableRow>
  );
}
